import { ReactNode } from "react";
import classNames from "classnames";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { HStack } from "@design-system/HStack/HStack";
import { EditorIssueBar } from "./editor/EditorIssueBar";
import styles from "./IssueNavigationCommandIsland.module.scss";

interface Props {
    completeStatus: ReactNode;
    issueLabel: string;
    issueCount: number;
    currentIssueIndex: number;
    currentIssueMessage: string | undefined;
    onNavigateIssue: (index: number) => void;
    children: ReactNode;
}

export const IssueNavigationCommandIsland = ({
    completeStatus,
    issueLabel,
    issueCount,
    currentIssueIndex,
    currentIssueMessage,
    onNavigateIssue,
    children,
}: Props) => (
    <CommandIsland sticky>
        <HStack gap={8} align="center" className={styles.islandLeading}>
            <div className={styles.islandLeadingItem}>
                {issueCount > 0 ? (
                    <EditorIssueBar
                        label={issueLabel}
                        issueCount={issueCount}
                        currentIssueIndex={currentIssueIndex}
                        currentIssueMessage={currentIssueMessage}
                        onNavigateIssue={onNavigateIssue}
                    />
                ) : (
                    completeStatus
                )}
            </div>
        </HStack>
        <HStack
            gap={8}
            align="center"
            className={classNames("ml-auto", styles.islandActions)}
        >
            {children}
        </HStack>
    </CommandIsland>
);
